module.exports = __webpack_public_path__ + "6c4a0dbc/img/splash-icon.07a7c465.svg";